import React, { useContext } from 'react'
import { Route, Redirect } from 'react-router-dom'
import { AuthContext, AuthState } from '../../../contexts/authContext'
import { UserType } from '../../../contexts/authContext'

type SignInRouteProps = {
  path: string
  component: React.FC<any>
}

/**
 * Redirects the page to dashboard if a signin-related page
 * is accessed by an already signed in user
 */
const SignInRoute: React.FC<SignInRouteProps> = ({ path, component }) => {
  const authContext = useContext(AuthContext)

  if (authContext?.authState === AuthState.signedIn) {
    // User is already logged in, redirect to redirectTo url if present
    // ...or to either migrant or vendor dashboard
    let url = '/'
    if (authContext.redirectTo) {
      url = authContext.redirectTo
      authContext.setRedirectTo(null)
    } else if (authContext?.userType === UserType.vendor) {
      url = '/vendor'
    }

    return (
      <Route
        exact
        path={path}
        render={({ location }) => (
          <Redirect
            to={{
              pathname: url,
              state: { from: location }
            }}
          />
        )}
      />
    )
  } else {
    // All checks passed, display intended route component
    return <Route exact path={path} component={component} />
  }
}

export default SignInRoute
